import { render } from "./OrderServiceShow.vue?vue&type=template&id=76f9e5c3"
import script from "./OrderServiceShow.vue?vue&type=script&lang=js"
export * from "./OrderServiceShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__